
import { Options, Vue } from "vue-class-component";
import Button from "./Button.vue";
import Select from "./Select.vue";
import Language from "./Language.vue";

@Options({
  components: {
    Button,
    Select,
    Language,
  },
  props: {
    guestTypes: Array,
    programs: Array,
    text: String,
    link: String,
    route: Object,
    showSelect: Boolean,
    stateMenuNumber: Number,
    stateMenuFilter: String,
    stateMenuMenu: Number,
  },
})
export default class MainHeader extends Vue {
  guestTypes!: string[];
  programs!: string[];
  text!: string;
  link!: string;
  route!: object;
  showSelect!: boolean;
  stateMenuNumber!: string;
  stateMenuFilter!: number;
  stateMenuMenu!: string;
}
